module.exports = __webpack_public_path__ + "static/media/mk-educational-society-logo.cb1a09a9.png";